module.exports = __webpack_public_path__ + "img/big.2995546d.jpg";